import logoMainForm from "../../assets/images/logo-main-form.png";
import { useState, useRef } from "react";
import { MessageForm } from "./widgets/MessageForm";
import { setStatusFormAlert } from "../../hooks/AlertsForm";
import { getValueFromInputElement } from "../../utils/inputRefHandlers";
import { recoverPassword } from "../../api/user/userService";


export function ForgotPassword(props) {
  const { setSessionForm } = props;
  const inputRefs = useRef({ email: "" });
  const timeToRemoveMessage = useRef(0);
  const [hasProcessingInformation, setHasProcessingInformation] = useState(false);
  const [formRequestStatus, setFormRequestStatus] = useState({
    typeAlert: "",
    message: ""
  });
  const handleForgotPasswords = async (e) => {
    e.preventDefault();
    setHasProcessingInformation(true);
    recoverPassword(inputRefs.current.email).then((data) => {
      let statusHttp = data["statusHttp"];
      let message = data["message"];
      let response = { "message": message };
      setHasProcessingInformation(false);
      switch (statusHttp) {
        case 0:
          setStatusFormAlert(response, "alert-danger", setFormRequestStatus, timeToRemoveMessage);
          break;
        case 400:
          setStatusFormAlert(response, "alert-danger", setFormRequestStatus, timeToRemoveMessage);
          break;
        case 404:
          setStatusFormAlert(response, "alert-danger", setFormRequestStatus, timeToRemoveMessage);
          break;
        case 200:
          setStatusFormAlert(response, "alert-success", setFormRequestStatus, timeToRemoveMessage);
          break;
      }
    });
  };

  return (
    <div className="home-px-5 d-flex align-items-center justify-content-center home-container-form">
      <div className="home-area-form">
        <span className="home-container-main-icon-form">
          <img
            src={logoMainForm}
            alt="Ícone de parceiros"
            className="home-main-icon-form"
          />
        </span>
        <br />
        <MessageForm
          formRequestStatus={formRequestStatus}
          hasProcessingInformation={hasProcessingInformation}
        />
        <br />

        <span className="home-form-title">Recuperar Senha</span>
        <div>
          <form className="w-100" onSubmit={handleForgotPasswords}>
            <div
              className="home-field-form-to-fill"
              data-validate="Enter email"
            >
              <input
                className="home-input-form"
                type="email"
                name="email"
                placeholder="E-mail"
                required
                onChange={(e) => {
                  getValueFromInputElement(e, inputRefs);
                }}
              />
              <span
                className="home-icon-form-input"
                data-placeholder="📧"
              ></span>
            </div>

            <div className="home-container-btn-submit-form">
              <button className="home-btn-submit-form" type="submit">
                Recuperar
              </button>
            </div>
            <hr />
          </form>
          <div className="home-container-other-option-form">
            <div className="home-sub-container-other-option-form">
              <div className="col d-flex">
                <a
                  className="home-text-other-option-form text-start"
                  onClick={() => {
                    setSessionForm("register");
                  }}
                >
                  <p>Cadastrar</p>
                </a>
              </div>
              <div className="col d-flex">
                <a
                  className="home-text-other-option-form text-end"
                  onClick={() => {
                    setSessionForm("login");
                  }}
                >
                  Logar
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
